import React from 'react'

const Illustrative = () => {
    return (
        <section id="non-profitDiv" className="non-profit-customers">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-lg-12 text-center">
                        <h2 className="h1">
                            Illustrative Charity/Non-profit Customers
                        </h2>
                        <p>Right Cause consultants have the experience and deep product knowledge that comes from years
                            of delivering diverse projects with
                            customers ranging from one-person charities to large multinational NGOs all of types. </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="infograph_wrapper">
                            <div className="infographFirst_div">
                                <div className="iconWrapper hospice">
                                    <p className="iconName">Hospice</p>
                                    <div className="icon_div">
                                        <i className="icon-hospice"></i>
                                    </div>
                                </div>
                                <div className="iconWrapper healthcare">
                                    <p className="iconName">Healthcare</p>
                                    <div className="icon_div">
                                        <i className="icon-healthcare"></i>
                                    </div>
                                </div>
                                <div className="iconWrapper welfare">
                                    <p className="iconName">Welfare<br />
                                        organizations</p>
                                    <div className="icon_div">
                                        <span className="icon-welfare"></span>
                                    </div>
                                </div>

                                <div className="iconWrapper chambers">
                                    <p className="iconName">Chambers</p>
                                    <div className="icon_div">
                                        <i className="icon-chambers"></i>
                                    </div>
                                </div>
                                <div className="iconWrapper membership">
                                    <p className="iconName">Membership Associations</p>
                                    <div className="icon_div">
                                        <i className="icon-membership"></i>
                                    </div>
                                </div>

                                <div className="iconWrapper churches">
                                    <p className="iconName">Churches &<br />
                                        Religious<br />
                                        Institutes </p>
                                    <div className="icon_div">
                                        <i className="icon-churches_1"></i>
                                    </div>
                                </div>
                            </div>
                            <div className="infographSecond_div">
                                <div className="iconWrapper faith">
                                    <p className="iconName">Faith<br />charities</p>
                                    <div className="icon_div">
                                        <i className="icon-faith"></i>
                                    </div>
                                </div>
                                <div className="iconWrapper education">
                                    <p className="iconName">Education<br />
                                        establishments </p>
                                    <div className="icon_div">
                                        <i className="icon-education"></i>
                                    </div>
                                </div>
                                <div className="iconWrapper govt">
                                    <p className="iconName">Government<br />
                                        Agencies</p>
                                    <div className="icon_div">
                                        <i className="icon-govt"></i>
                                    </div>
                                </div>
                                <div className="iconWrapper student">
                                    <p className="iconName">Student<br />
                                        Union</p>
                                    <div className="icon_div">
                                        <i className="icon-student"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Illustrative